import './style.css';
import * as THREE from 'three';
import GUI from 'lil-gui';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import * as FOUR from './four/Four.js';

const myHyperCube = new FOUR.HyperCube(4);

/* 
Debug
*/
// const gui = new GUI({ width: 200 });
// gui.close();

// window.addEventListener('keydown', (event) => {
//   if (event.key === 'h') {
//     if (gui._hidden) gui.show();
//     else gui.hide();
//   }
// });

// Tranform Hypercube to 3 dimensions
let projected3d = [];

const geometry = new THREE.BufferGeometry();
const positions = new Float32Array(myHyperCube.points.length * 3);

// Rotations
let transform4D = {
  scale: 1,
  angleXY: 0.1,
  angleXZ: 0,
  angleXW: 0,
  angleYZ: 0,
  angleYW: 0,
  angleZW: 0,
};

// Debug
// gui.add(transform4D, 'scale').min(0.01).max(3).step(0.01).name('Scale');
// gui
//   .add(transform4D, 'angleXY')
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.01)
//   .name('Rotate XY');
// gui
//   .add(transform4D, 'angleXZ')
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.01)
//   .name('Rotate XZ');
// gui
//   .add(transform4D, 'angleXW')
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.01)
//   .name('Rotate XW');
// gui
//   .add(transform4D, 'angleYZ')
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.01)
//   .name('Rotate YZ');
// gui
//   .add(transform4D, 'angleYW')
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.01)
//   .name('Rotate YW');
// gui
//   .add(transform4D, 'angleZW')
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.01)
//   .name('Rotate ZW');

for (let i = 0; i < myHyperCube.points.length; i++) {
  let transformed = myHyperCube.points[i];

  let r = 3; // Distance to origin from viewpoint
  let f = 2; // Distance from origin to projection plane

  let w = r - f / (r - transformed[3]);

  const projection = [
    [w, 0, 0, 0],
    [0, w, 0, 0],
    [0, 0, w, 0],
  ];

  // let projected = matmul(projection, transformed);
  let newX = ((r - f) * transformed[0]) / (r - transformed[3]);
  let newY = ((r - f) * transformed[1]) / (r - transformed[3]);
  let newZ = ((r - f) * transformed[2]) / (r - transformed[3]);

  let projected = new FOUR.Point4D(newX, newY, newZ, 0);

  // projected.mult(width / 4);
  projected3d[i] = projected;
  positions[i * 3] = projected3d[i].x;
  positions[i * 3 + 1] = projected3d[i].y;
  positions[i * 3 + 2] = projected3d[i].z;
}

geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color(0x0000cc);
// Add Vertices to scene
const pointsMaterial = new THREE.PointsMaterial({
  size: 4,
  sizeAttenuation: false,
});
const points = new THREE.Points(geometry, pointsMaterial);
points.geometry.attributes.position.needsUpdate = true;
scene.add(points);

/**
 * Lines
 */

const linesGeometry = new THREE.BufferGeometry();
const linePositions = new Float32Array(myHyperCube.lines.length * 3 * 2);

// For all the lines in the hypercube add pairs of points
for (let i = 0; i < myHyperCube.lines.length; i++) {
  // First line point vertices
  linePositions[i * 3 * 2] = projected3d[myHyperCube.lines[i][0]].x;
  linePositions[i * 3 * 2 + 1] = projected3d[myHyperCube.lines[i][0]].y;
  linePositions[i * 3 * 2 + 2] = projected3d[myHyperCube.lines[i][0]].z;

  // First line point vertices
  linePositions[i * 3 * 2 + 3] = projected3d[myHyperCube.lines[i][1]].x;
  linePositions[i * 3 * 2 + 4] = projected3d[myHyperCube.lines[i][1]].y;
  linePositions[i * 3 * 2 + 5] = projected3d[myHyperCube.lines[i][1]].z;
}

linesGeometry.setAttribute(
  'position',
  new THREE.BufferAttribute(linePositions, 3)
);

const lineMaterial = new THREE.LineBasicMaterial({
  color: 0xffffff,
  linewidth: 6,
});
const line = new THREE.LineSegments(linesGeometry, lineMaterial);

scene.add(line);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.x = 1;
camera.position.y = 1;
camera.position.z = 1;
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  // Update Hypercube
  myHyperCube.transformUpdate(
    transform4D.scale,
    (transform4D.angleXY += 0.001),
    (transform4D.angleXZ += 0.001),
    (transform4D.angleXW += 0.001),
    transform4D.angleYZ,
    transform4D.angleYW,
    transform4D.angleZW,
    points,
    line
  );

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
